module.exports = __webpack_public_path__ + "assets/27a03e0392811eeb03b8939297a619b1.mp4";